import { buttonShuffle } from "../helpers-board.js";
import { sample } from "../utils.js";

/*
 * Randomly reflects the text in a button on the x/y axis
 */
function mirrorText({ board, buttons, initialPositions }) {
  buttonShuffle({ board, buttons, initialPositions });
  buttons.forEach((btn) => {
    btn.style.transform += ` scale(${sample([-1, 1])}, ${sample([-1, 1])})`;
  });
}


export default mirrorText;
